export const pageGetGlobal = s => s.page.get('page').toJS().Global;
export const pageGetPage = s => s.page.get('page').toJS().Page;
export const pageGetData = s => s.page.get('page').toJS();
